import List from './list.vue';
import Item from './item.vue';

List.Item = Item;
export default List;


// WEBPACK FOOTER //
// ./src/components/list/index.js